import styles from "./StateView.module.css";

export function LoadingView({ label = "Loading…" }: { label?: string }) {
  return <div className={styles.state}>{label}</div>;
}

export function ErrorView({
  message,
  onRetry,
}: {
  message: string;
  onRetry?: () => void;
}) {
  return (
    <div className={`${styles.state} ${styles.stateError}`}>
      <span>{message}</span>
      {onRetry ? (
        <button type="button" className={styles.retry} onClick={onRetry}>
          Retry
        </button>
      ) : null}
    </div>
  );
}

export function EmptyView({ label }: { label: string }) {
  return <div className={`${styles.state} ${styles.stateMuted}`}>{label}</div>;
}
